import React from 'react';
import { useTranslation } from 'react-i18next';
import { KeyboardShortcut } from 'shared/components/ui/keyboard-shortcut';

import * as Styled from './popup-menu.style';
import { ButtonVariants, Colors } from './types';

export type PopupMenuButtonProps = React.ComponentProps<'button'> & {
  start?: React.ReactNode;
  end?: React.ReactNode;
  shortcut?: string[];
  startColor?: Colors;
  endColor?: Colors;
  textColor?: Colors;
  isPremium?: boolean;
  isSelected?: boolean;
  indentationLevel?: number;
  overflowEllipsis?: boolean;
  compact?: boolean;
  as?: string;
  variant?: ButtonVariants;
};

export const PopupMenuButton = React.forwardRef<
  HTMLButtonElement,
  PopupMenuButtonProps
>(
  (
    {
      start,
      end,
      children,
      shortcut,
      startColor,
      endColor,
      textColor,
      isPremium,
      isSelected,
      indentationLevel = 0,
      overflowEllipsis,
      compact,
      variant,
      ...rest
    },
    ref,
  ) => {
    const { t } = useTranslation();
    return (
      <Styled.Button
        ref={ref}
        $color={textColor}
        $isSelected={!!isSelected}
        $indentationLevel={indentationLevel}
        $compact={!!compact}
        $variant={variant}
        {...rest}
      >
        {!!start && (
          <Styled.AffixContainer $isSelected={!!isSelected} $color={startColor}>
            {start}
          </Styled.AffixContainer>
        )}
        <Styled.ButtonContent $overflowEllipsis={!!overflowEllipsis}>
          {children}
        </Styled.ButtonContent>
        {isPremium && (
          <Styled.PremiumLabel>
            {t('general.labels.premium')}
          </Styled.PremiumLabel>
        )}
        {(!!shortcut || !!end) && (
          <Styled.RightSideItems>
            {!!shortcut && <KeyboardShortcut shortcut={shortcut} />}
            {!!end && (
              <Styled.AffixContainer
                $isSelected={!!isSelected}
                $color={endColor}
              >
                {end}
              </Styled.AffixContainer>
            )}
          </Styled.RightSideItems>
        )}
      </Styled.Button>
    );
  },
);
